module.exports = __webpack_public_path__ + "img/805dafd08d1698fcc13f963aa41e3e0d.6e4b8dba.jpg";